import { styled, Typography } from "@mui/material";

export const GroupLabel = styled(Typography)(({ theme }) => ({
  display: "block",
  marginBottom: theme.spacing(0.5),
  color: theme.palette.text.secondary,
  "&.first": {
    marginTop: 0,
  },
  "&:not(.first)": {
    marginTop: theme.spacing(2),
  },
}));
